import styled from 'styled-components';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

import { PlaceholderIcon } from './PlaceholderIcon/index.tsx';

const Wrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  --c-gradient-card-placeholder-common: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    var(--c-nd-100);
  --c-gradient-card-placeholder-limited: linear-gradient(
      180deg,
      rgba(211, 153, 57, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    var(--c-nd-100);
  --c-gradient-card-placeholder-rare: linear-gradient(
      180deg,
      rgba(168, 27, 29, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    var(--c-nd-100);
  --c-gradient-card-placeholder-superRare: linear-gradient(
      180deg,
      rgba(62, 103, 240, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    var(--c-nd-100);
  --c-gradient-card-placeholder-unique: linear-gradient(
      180deg,
      rgba(63, 62, 61, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    var(--c-nd-100);
  background: var(--c-gradient-card-placeholder-common);
  &.limited {
    background: var(--c-gradient-card-placeholder-limited);
  }
  &.rare {
    background: var(--c-gradient-card-placeholder-rare);
  }
  &.super_rare {
    background: var(--c-gradient-card-placeholder-superRare);
  }
  &.unique {
    background: var(--c-gradient-card-placeholder-unique);
  }
  color: var(--c-white);
  aspect-ratio: var(--card-aspect-ratio);
  border-radius: var(--unit);
`;

type Props = {
  rarity: Rarity;
  empty: boolean;
  locked: boolean;
  available: boolean;
  loading?: boolean;
};

export const CardPlaceholder = ({
  rarity,
  empty,
  locked,
  available,
  loading,
}: Props) => {
  return (
    <Wrapper className={rarity}>
      {!loading && (
        <PlaceholderIcon
          rarity={rarity}
          empty={empty}
          locked={locked}
          available={available}
        />
      )}
    </Wrapper>
  );
};
